<template>
  <div>
    <div class="font-bold pb-2" v-text="i18n.amounts.label"></div>
    <div class="">
      <list-item
        :label="data.credits.label + ' ' + i18n.rendering_credits"
        class="border-gray-200"
      >
        <span v-html="data.credits.data"></span>
      </list-item>
      <list-item
        v-if="data.promotion"
        :label="data.promotion"
        class="bg-promo-bg text-promo-fg rounded-t -mb-1"
      ></list-item>
      <list-item
        v-if="data.promotion"
        :label="freeCreditsLabel"
        class="bg-promo-bg text-promo-fg rounded-b"
      ></list-item>
      <list-item v-else :label="freeCreditsLabel" class="border-gray-200">
        <span v-html="data.free_credits.data"></span>
      </list-item>
      <list-item
        :label="i18n.vat + '&nbsp;(' + data.vat.label + ')'"
        class="border-gray-200"
      >
        <span v-html="data.vat.data"></span>
      </list-item>
      <list-item :label="'<b>' + i18n.total + '</b>'">
        <span v-html="data.total.data" class="font-bold"></span>
      </list-item>
    </div>
  </div>
</template>

<script>
import ListItem from "../Design/ListItem";

export default {
  props: ["data"],
  components: { ListItem },
  mixins: [],
  data: function () {
    return {};
  },
  methods: {},
  computed: {
    freeCreditsLabel() {
      let label =
        this.data.free_credits.label + " " + this.i18n.free_rendering_credits;
      if (this.data.bonusRate > 0) {
        label += " (" + this.data.bonusRate + "%)";
      }

      return label;
    },
    i18n() {
      if (this.$store.state.safe.i18n !== undefined) {
        return {
          ...this.$store.state.safe.i18n.new_refill.billing.confirmation,
          ...this.$store.state.safe.i18n.invoice.amounts,
        };
      }

      return undefined;
    },
  },
  mounted() {},
};
</script>

<style></style>
